'use client'

import { Spinner } from '@/_components/ui/spinner'
import { cn } from '@/_lib/utils'

export type AOrderLoadingProps = {
	/** Optional text displayed below the spinner to describe what is loading. */
	message?: string
	/** Overrides default message color (e.g. on dark panels). */
	messageClassName?: string
	/** Extra Tailwind classes applied to the wrapper `<div>`. */
	className?: string
}

/**
 * Full-area loading placeholder used between async data fetches in the order flow.
 * Shows a centered spinner and an optional status message.
 */
export function AOrderLoading({ message, messageClassName, className }: AOrderLoadingProps) {
	return (
		<div
			className={cn(
				'box_ordering-system-hero_right flex min-w-0 max-w-full flex-col items-center justify-center gap-3 overflow-x-hidden min-h-[calc(100vh-270px)]',
				className
			)}
		>
			<Spinner className='size-8 text-medante-purple-dark' aria-hidden />
			{message ? (
				<p className={cn('text-center text-sm text-purple/70', messageClassName)} role='status'>
					{message}
				</p>
			) : null}
		</div>
	)
}
